/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateTemplate.defs.js'
export * as $defs from './updateTemplate.defs.js'
